import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import VariableLogo from '@/components/VariableLogo.vue';
import BackButton from '@/components/BackButton.vue';
import { TypeOrder } from '@/store/state';
let CommonHeader = class CommonHeader extends Vue {
    constructor() {
        super(...arguments);
        this.profile = false;
        this.typeOrder = this.$store.state.typeOrder;
        this.menu = this.$store.state.menu;
    }
    goBack() {
        if (this.$router.currentRoute.path == '/SummaryDeliveryConfirm') {
            this.$router.push("/menu");
        }
        else if (this.$router.currentRoute.path == '/locations') {
            this.$router.push("/summary");
        }
        else {
            history.back();
        }
    }
    goToMarket() {
        this.$router.push("/");
    }
    goToOrderOrProfile() {
        if (this.$router.currentRoute.path == '/SummaryDeliveryConfirm') {
            this.$router.push("/menu");
        }
        else if (this.profile && !this.setOrden) {
            this.$store.state.user ? this.$router.push("/profile") : this.$router.push("/login");
        }
        else {
            this.$router.currentRoute.path == '/menu' ? this.$router.push("/order") : this.$router.push("/menu");
        }
    }
    created() {
        if (this.menu) {
            if (this.typeOrder == TypeOrder.DELIVERY || this.typeOrder == TypeOrder.COLLECT) {
                this.profile = true;
            }
            else {
                this.menu.useLogin ? this.profile = true : this.profile = false;
            }
        }
    }
};
__decorate([
    Prop({ default: '' })
], CommonHeader.prototype, "title", void 0);
__decorate([
    Prop({ default: true })
], CommonHeader.prototype, "showBackButton", void 0);
__decorate([
    Prop({ default: true })
], CommonHeader.prototype, "showIcon", void 0);
__decorate([
    Prop({ default: false })
], CommonHeader.prototype, "setOrden", void 0);
CommonHeader = __decorate([
    Component({
        components: {
            VariableLogo,
            BackButton
        }
    })
], CommonHeader);
export default CommonHeader;
